<template>
  <div>
    <Modal v-model="showWin" :title="isSelf ? '预备方案' : '治疗方案'" width="800" class-name="treatment-plan-modal"
      :footer-hide="disabled" :mask-closable="false" draggable :before-close="close">
      <div class="treatment-plan" :class="{ disabled }" v-if="info">
        <div class="hender">
          <div class="patient-info">
            <span class="patient-name">{{ info.patientName }}</span>
            <span class="patient-gender">{{ common.gender(info.gender) }}</span>
            <span class="patient-age">{{ info.patientAge }}岁</span>
            <span>{{ info.cellphoneNo }}</span>
            <span>{{ info.diseaseName }}</span>
          </div>
          <div class="condition" v-if="!isSelf">
            <div class="c-title">患者病情信息（病程专家收集）</div>
            <div class="c-content" v-if="medicalInfo.taskStatus">
              <div class="c-date">
                {{ medicalInfo.infoDate }}：{{
                  medicalInfo.taskStatus == 1 ? "接通患者" : "未接通患者"
                }}。
              </div>
              <symptomInfo :list="medicalInfo.symptomInfo" />
              <div class="bt b4">其他：{{ medicalInfo.medicalInfo }}</div>
            </div>
            <div class="c-content other" v-else>等待病程专家完成收集流程</div>
          </div>
          <div class="utabs-box fjcsb">
            <utabs :list="formDynamic.items" v-model="tabValue" type="utabs-type2" />
            <Button v-if="!disabled" @click="quote">引用上次方案</Button>
            <Button v-if="
              disabled &&
              (info.expertiseType == 4 ||
                (info.expertiseType == 1 &&
                  [1, 2].includes(medicalInfo.taskStatus))) &&
              activeItem.isEnd
            " @click="edit">编辑</Button>
          </div>
        </div>
        <div class="form-box">
          <Form ref="formDynamic" :model="formDynamic" label-position="top" footer-hide>
            <div class="item" v-for="(item, index) in formDynamic.items" :key="index" v-show="tabValue === item.value">
              <FormItem label="方案说明" :prop="'items.' + index + '.planExplain'" :rules="isSelf
                ? {
                  required: true,
                  message: '请输入' + item.label + '的方案说明',
                  trigger: 'blur',
                }
                : null
                ">
                <template #label>
                  <span>方案说明</span>
                  <span class="other">（
                    <i class="red">{{ item.label }}</i>
                    时如何向患者解释说明）</span>
                  <strong v-if="item.explainSupplement">（{{ item.supplementUserName }}修改补充）</strong>
                </template>
                <Input :disabled="disabled" type="textarea" :rows="isSelf ? 10 : 4" v-model="item.planExplain"
                  :placeholder="'结合患者的上次病情，若' + item.label + '时如何向患者解释说明'
                    " :maxlength="2000" show-word-limit></Input>
              </FormItem>
              <FormItem v-if="!isSelf" label="处方" :prop="'items.' + index + '.medicalRecordInfo'" :rules="isSelf
                ? [
                  {
                    type: 'array',
                    required: true,
                    message: '请输入' + item.label + '的处方',
                    trigger: 'blur',
                  },
                  { validator: validatePrescription, trigger: 'change' },
                ]
                : null
                ">
                <template #label>
                  <span>处方</span>
                  <strong v-if="item.recordSupplement">（{{ item.supplementUserName }}修改补充）</strong>
                </template>
                <prescriptionInput :disabled="disabled" :info="info" v-model="item.medicalRecordInfo" v-if="showWin" />
              </FormItem>
            </div>
          </Form>
        </div>
      </div>
      <template #footer>
        <div class="footer-box fjcsb">
          <div>
            <Button v-if="showBtn" @click="showTransferFun">转给上级医生</Button>
          </div>
          <div>
            <Button @click="close" style="margin-right: 10px">取消</Button>
            <Tooltip v-if="!medicalInfo.taskStatus && info.expertiseType == 1" content="请在咨询医馆的病程专家完成病情收集流程后再来回复治疗方案"
              placement="top-end" effect="dark" :disabled="medicalInfo.taskStatus">
              <Button :disabled="!medicalInfo.taskStatus" type="primary"
                @click="handleSubmit('formDynamic')">发送</Button>
            </Tooltip>
            <Button v-else type="primary" @click="handleSubmit('formDynamic')">{{
              isSupplement ? "完成补充" : isSelf ? "确定" : "发送"
              }}</Button>
          </div>
        </div>
        <div v-if="showBtn" class="tip">答不来的转给上级医生（徐医生）回复</div>
      </template>
    </Modal>
    <transferDoctor v-model="showTransfer" @cancel="handleTransferCancel" @confirm="handleTransferConfirm" />
  </div>
</template>

<script>
import symptomInfo from "./symptomInfo.vue";
import request from "@/utils/request";
import prescriptionInput from "./prescriptionInput.vue";
import transferDoctor from "./transferDoctor.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => { },
    },
    activeItem: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    prescriptionInput,
    symptomInfo,
    transferDoctor,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isSelf() {
      return [4, 5, "4", "5"].includes(this.info.expertiseType);
    },
    name() {
      return this.data;
    },
    showBtn() {
      return (this.info.benchmarkDoctorName != "徐绍萍" && !this.info.forwardDoctorId) && this.activeItem.recordType != 5 && this.medicalInfo.taskStatus && this.info.expertiseType == 1;
    },
  },
  data() {
    return {
      medicalInfo: {},
      lastMedicalExpertisePlan: [],
      isSupplement: false,
      isEdit: false,
      disabled: false,
      showWin: false,
      tabValue: 0,
      index: 0,
      tabList: [],
      formDynamic: {
        items: [],
      },
      oldData: [], //旧数据 用于比较是否有修改
      typeList: ["病情好转", "病情加重", "病情同前"],
      showTransfer: false,
    };
  },
  methods: {
    getMedicalInfo() {
      this.medicalInfo = {};
      request
        .post("/zhbusiness/getMedicalInfo", {
          meId: this.info.meId,
          merId: this.activeItem ? this.activeItem.merId : "",
        })
        .then((res) => {
          let o = res.result;
          o.symptomInfo = o.symptomInfo ? JSON.parse(o.symptomInfo) : [];

          // 测试
          /*
          o.symptomInfo = [
            { dsId: 8, dsName: "发热", symptomChanges: 1 },
            { dsId: 10, dsName: "黄稠痰", symptomChanges: 2 },
            { dsId: 19, dsName: "面色萎黄", symptomChanges: 3 },
            { dsId: 38, dsName: "舌苔少", symptomChanges: 1 },
            { dsId: 30120, dsName: "口苦", symptomChanges: 2 },
            { dsId: 30148, dsName: "大便调", symptomChanges: 3 },
            { dsId: 30150, dsName: "纳可", symptomChanges: 1 },
            { dsId: 30154, dsName: "咳嗽", symptomChanges: 0 },
            { dsId: 30177, dsName: "尿急", symptomChanges: 0 },
            { dsId: 30216, dsName: "病情好转", symptomChanges: 0 },
            { dsId: 30241, dsName: "四肢凉", symptomChanges: 0 },
            { dsId: 30247, dsName: "舌苔薄白(正常苔)", symptomChanges: 0 },
            { dsId: 30267, dsName: "嗜睡", symptomChanges: 0 },
            { dsId: 30304, dsName: "喉中痰鸣", symptomChanges: 0 },
            { dsId: 30308, dsName: "哮鸣", symptomChanges: 0 },
            { dsId: 30394, dsName: "脱肛", symptomChanges: 0 },
            { dsId: 30417, dsName: "初诊", symptomChanges: 0 },
            { dsId: 30430, dsName: "寐安", symptomChanges: 0 },
            { dsId: 50391, dsName: "智力障碍", symptomChanges: 0 },
            { dsId: 50519, dsName: "舌边紫暗", symptomChanges: 0 },
            { dsId: 50592, dsName: "冷汗淋漓", symptomChanges: 0 },
          ];
          o.taskStatus = 2;
          */
          //  测试
          // o.taskStatus = 1;

          this.medicalInfo = o;
        });
    },
    showDelFun(item, index) {
      if (this.disabled) {
        return false;
      } else {
        return index != 0;
      }
    },

    validatePrescription(rule, value, callback) {
      if (value.some((i) => !i.Amount)) {
        callback(new Error("请输入数量"));
      } else {
        callback();
      }
    },

    validatePrescription2(list) {
      if (list.length == 0 || list.some((i) => !i.Amount)) {
        return false;
      } else {
        return true;
      }
    },

    del(index) {
      this.$Modal.confirm({
        title: "提示",
        content: "删除思路将无法恢复，确认删除吗？",
        onOk: () => {
          if (this.formDynamic.items[index].value == this.tabValue) {
            this.tabValue = this.formDynamic.items[0].value;
          }
          this.formDynamic.items.splice(index, 1);
        },
      });
    },
    add() {
      let list = this.lastMedicalExpertisePlan;
      this.typeList.forEach((i, index) => {
        let item = list.find((j) => j.planName == i);
        if (item) {
          item.medicalRecordInfo = JSON.parse(item.medicalRecordInfo);
        }
        this.formDynamic.items.push({
          planExplain: item ? item.planExplain : "",
          medicalRecordInfo: item ? item.medicalRecordInfo : [],
          label: i,
          value: index,
        });
      });
      this.tabValue = 0;
    },

    setTabList() {
      this.add();
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isSelf) {
            this.submit(true);
          } else {
            this.validate();
          }
        } else {
          this.$Message.error("请将表单填写完整");
        }
      });
    },

    validate() {
      if (this.isSupplement && !this.isChange()) {
        this.$Message.error("请修改后完成补充");
        return;
      }
      let list = this.formDynamic.items;
      let arr = list.filter((i) => {
        if (
          i.planExplain.trim() &&
          this.validatePrescription2(i.medicalRecordInfo)
        ) {
          return true;
        } else {
          return false;
        }
      });
      if (arr.length) {
        this.submit(arr.length == 3);
      } else {
        this.$Message.error(
          "请确保“病情好转、加重、同前”中至少一种有对应的方案说明及处方"
        );
      }
    },

    // 是否修改过内容
    isChange() {
      let list = this.formDynamic.items;
      return list.some((i, index) => {
        let o = this.oldData[index];
        return (
          i.planExplain.trim() != o.planExplain.trim() ||
          JSON.stringify(i.medicalRecordInfo) !=
          JSON.stringify(o.medicalRecordInfo)
        );
      });
    },

    validate2() {
      let label = "";
      let list = this.formDynamic.items;
      let flag1 = false; //是否未填方案说明
      let flag2 = false; //是否未填处方
      let arr = list.filter((i) => {
        if (
          i.planExplain.trim() &&
          this.validatePrescription2(i.medicalRecordInfo)
        ) {
          return true;
        } else {
          if (i.planExplain.trim()) {
            if (!this.validatePrescription2(i.medicalRecordInfo)) {
              flag2 = true;
              label = i.label;
            }
          } else if (this.validatePrescription2(i.medicalRecordInfo)) {
            flag1 = true;
            label = i.label;
          }
          return false;
        }
      });
      if (arr.length && !flag1 && !flag2) {
        this.submit();
      } else {
        let msg =
          "请从“病情好转、加重、同前”中至少选一种，填写对应的方案说明及处方。";
        if (flag1) msg = `请填写 ${label} 的方案说明`;
        if (flag2) msg = `请填写 ${label} 的处方`;
        this.$Message.error(msg);
      }
    },

    handleReset(name) {
      this.$refs[name].resetFields();
    },

    // "integrityType 完整性 1完整 2 不完整"
    submit(integrityType) {
      let api = "";
      if (this.info.expertiseType == 6) {
        api = "/zhbusiness/supplementMedicalExpertisePlan";
      } else if (this.info.expertiseType == 4) {
        if (this.isEdit) {
          api = "/zhbusiness/updateMedicalExpertisePreparatoryPlan";
        } else {
          api = "/zhbusiness/saveMedicalExpertisePreparatoryPlan";
        }
      } else {
        if (this.isEdit && this.info.expertiseType == 1) {
          api = "/zhbusiness/updateMedicalExpertisePreparatoryPlan";
        } else {
          api = "/zhbusiness/saveMedicalExpertisePlan";
        }
      }
      if (this.isSelf || this.isSupplement) {
        this.postData(api, integrityType);
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "发送后将无法撤回，确定发送吗？",
          onOk: () => {
            this.postData(api, integrityType);
          },
        });
      }
    },

    postData(api, integrityType) {
      let plan = this.common.clone(this.formDynamic.items).map((i) => {
        i.medicalRecordInfo = JSON.stringify(i.medicalRecordInfo);
        i.planName = i.label;
        return i;
      });
      let obj = {
        meId: this.info.meId,
        merId: this.activeItem ? this.activeItem.merId : "",
        plan,
        integrityType: integrityType ? 1 : 2, //"完整性 1完整 2 不完整"
      };
      this.request.post(api, obj).then((res) => {
        this.$Message.success(res.result);
        this.showWin = false;
        this.$emit("close");
        this.$emit("change");
        this.info.planFlg = 1;
        this.info.benchmarkReadFlg = 1;
        this.info.supplementType = 1;
        this.info.readFlg = 1;
      });
    },

    close() {
      return new Promise((resolve, reject) => {
        if (this.disabled) {
          this.showWin = false;
          this.$emit("close");
          resolve();
        } else {
          this.$Modal.confirm({
            title: "提示",
            content: "退出将无法保存当前的内容，确定退出吗？",
            cancelText: "继续编辑",
            okText: "退出",
            onOk: () => {
              this.showWin = false;
              this.$emit("close");
              resolve();
            },
            onCancel: () => {
              reject();
            },
          });
        }
      });
    },

    edit() {
      this.disabled = false;
    },

    showTransferFun() {
      this.showTransfer = true;
    },

    handleTransferCancel() {
      this.showTransfer = false;
    },

    handleTransferConfirm() {
      request.post("/zhbusiness/forwardConsult", {
        meId: this.info.meId,
      }).then((res) => {
        this.$Message.success(res.result);
        this.showTransfer = false;
        this.showWin = false;
        this.$emit("close");
        this.$emit("transfer");
      });
    },

    // 引用上次方案
    quote() {
      this.getLastMedicalExpertisePlan();
    },
    getLastMedicalExpertisePlan() {
      let obj = {};
      if (this.activeItem && this.activeItem.merId) {
        obj = {
          merId: this.activeItem.merId,
          meType: 2,
        };
      } else {
        obj = {
          meType: 1,
        };
      }
      this.api2("getLastMedicalExpertisePlan", {
        meId: this.info.meId,
        ...obj,
      }).then((res) => {
        let list = res.result.filter((i) => this.typeList.includes(i.planName));
        if (list.length) {
          this.$Modal.confirm({
            title: "提示",
            content: "确定要引用吗?",
            onOk: () => {
              this.lastMedicalExpertisePlan = res.result;
              this.showFun();
            },
          });
        } else {
          this.$Message.warning("没有上次方案可以引用");
        }
      });
    },

    show(data, isSupplement) {
      this.lastMedicalExpertisePlan = [];
      this.showFun(data, isSupplement);
    },

    showFun(data, isSupplement) {
      if (data) {
        this.isSupplement = isSupplement;
        this.oldData = this.common.clone(data);
        this.disabled = isSupplement ? false : true;
        this.formDynamic.items = data;
        this.isEdit = true;
      } else {
        this.isSupplement = false;
        this.isEdit = false;
        this.disabled = false;
        this.formDynamic.items = [];
        this.index = 0;
        this.add();
      }
      this.showWin = true;
      this.getMedicalInfo();
    },

    init() {
      this.setTabList();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss">
.treatment-plan-modal {
  .treatment-plan.disabled {
    .ivu-form-item-label {
      &::before {
        display: none;
      }
    }
  }

  .patient-info {
    margin-bottom: 15px;

    &>span {
      margin-right: 15px;

      &.patient-name {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  .ivu-form-item-error-tip {
    padding-top: 0;
    font-size: 13px;
  }

  .ivu-form-item {
    margin-bottom: 5px;
  }

  .ivu-modal-content {
    background: #fff;
  }

  .ivu-input[disabled] {
    color: #555;
  }

  .other {
    color: #888;

    .red {
      font-style: normal;
    }
  }

  .condition {
    margin-bottom: 15px;

    .c-title {
      color: #888;
      margin-bottom: 5px;
    }

    .c-content {
      .c-date {
        padding-bottom: 10px;
      }
    }
  }

  .bt {
    display: inline-block;
    border-radius: 3px;
    margin: 0 10px 5px 0;
    padding: 2px 10px;
  }

  .b4 {
    background: #fff5e2;
    color: #8e6310;
  }

  .ivu-tooltip-inner {
    white-space: wrap;
    width: 300px;
  }

  .tip {
    font-size: 12px;
    opacity: 0.6;
    text-align: left;
    padding-top: 5px;
  }
}
</style>
